import { KS_DEPTS_LOADED, KS_DEPTS_ALL_LOADED } from '../actions/types';

const initialState = {
  loadingKSDepts: true,
  ksDepts: [],
  loadingAllKSDepts: true,
  allKSDepts: []
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case KS_DEPTS_LOADED:
      return {
        ...state,
        loadingKSDepts: false,
        ksDepts: [...payload]
      };
    case KS_DEPTS_ALL_LOADED:
      return {
        ...state,
        loadingAllKSDepts: false,
        allKSDepts: [...payload]
      };
    default:
      return state;
  }
};
